'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactSortablejs = require('react-sortablejs');var _reactSortablejs2 = _interopRequireDefault(_reactSortablejs);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);

var _ImageControls = require('../HelpComponents/ImageControls');var _ImageControls2 = _interopRequireDefault(_ImageControls);
var _ImageWrapper = require('../HelpComponents/ImageWrapper');var _ImageWrapper2 = _interopRequireDefault(_ImageWrapper);
var _components = require('../../../components');
var _UploadAssetWidget = require('../UploadAssetWidget.scss');var styles = _interopRequireWildcard(_UploadAssetWidget);
var _constants = require('../../../constants');function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

PreviewList = function (_Component) {_inherits(PreviewList, _Component);function PreviewList() {var _temp, _this, _ret;_classCallCheck(this, PreviewList);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    sortableOptions = {
      ghostClass: styles.sortableGhost,
      animation: 150,
      forceFallback: true,
      onStart: function onStart() {
        document.querySelector('.' + styles.fileUpload).classList.add(styles.noTransition);
        document.body.classList.add(styles.dragOnBody);
      },
      onEnd: function onEnd() {
        document.querySelector('.' + styles.fileUpload).classList.remove(styles.noTransition);
        document.body.classList.remove(styles.dragOnBody);
      } }, _this.


    sortableOnChange = function (order, sortableInstance, evt) {
      _this.props.onChange(order);
      var descriptionFields = evt.target.querySelectorAll('textarea');
      if (descriptionFields) {
        for (var index = 0; index < descriptionFields.length; index += 1) {
          descriptionFields[index].value = _this.props.items[index].description || null;
        }
      }
    }, _this.

    renderListItems = function (items) {
      if (!items || items && !items.length) {
        return null;
      }

      return items.map(function (item, index) {var _cx, _cx2;
        var isVideo = item.contentType === _constants.cloudinaryContentTypes.VIDEO;
        var isRaw = item.type === 'application/pdf' || item.raw;

        return (
          _react2.default.createElement('div', {
              className: (0, _classnames2.default)(
              styles.imageContainer, (_cx = {}, _cx[
              styles.videoList] = isVideo, _cx), (_cx2 = {}, _cx2[
              styles.mainImage] = !index, _cx2)),

              key: item._id,
              'data-id': index },

            _react2.default.createElement(_ImageControls2.default, {
              isTabletDevice: _this.props.isTabletDevice,
              mainImageTitle: !index &&
              _react2.default.createElement('div', { className: styles.mainImageTitle }, _this.props.translate('mainImage')),

              deleteFileTitle: _this.props.translate('deleteFile'),
              rotateImageTitle: _this.props.translate('rotateImage'),
              deleteImage: function deleteImage(evt) {return _this.props.deleteItem(evt, index, item);},
              rotateImage: function rotateImage(evt) {return _this.props.rotateImage(evt, index, item);},
              isVideo: isVideo,
              isRaw: isRaw }),


            _react2.default.createElement(_ImageWrapper2.default, {
              id: item._id,
              image: item.thumbnail ? item.thumbnail : null,
              angle: item.relativeAngle || 0,
              uploadInProgress: !!item.preview,
              isVideo: isVideo,
              isRaw: isRaw }),

            isRaw ?
            _react2.default.createElement('div', { className: styles.nameWrapper },
              _react2.default.createElement('p', null,
                item.name)) :


            _react2.default.createElement(_components.OMTextArea, {
              disabled: _this.props.uploadInProgress,
              onBlur: function onBlur(event) {return _this.props.addDescription(event.target.value, index, item);},
              maxLength: '24',
              placeholder: _this.props.translate('imageDescription'),
              initialValue: item.description })));




      });
    }, _temp), _possibleConstructorReturn(_this, _ret);}PreviewList.prototype.

  render = function render() {var _this2 = this;
    if (this.sortable) {
      this.sortable.option('disabled', this.props.uploadInProgress);
    }

    return (
      _react2.default.createElement('div', { className: styles.previewList },
        this.renderListItems(this.props.videos),
        _react2.default.createElement(_reactSortablejs2.default, {
            className: styles.sortableList,
            options: this.sortableOptions,
            onChange: this.sortableOnChange,
            ref: function ref(component) {if (component) {_this2.sortable = component.sortable;}} },

          this.renderListItems(this.props.items))));



  };return PreviewList;}(_react.Component);exports.default = PreviewList;


PreviewList.propTypes = {
  items: _propTypes2.default.array,
  videos: _propTypes2.default.array,
  onChange: _propTypes2.default.func,
  deleteItem: _propTypes2.default.func,
  uploadInProgress: _propTypes2.default.bool,
  translate: _propTypes2.default.func,
  addDescription: _propTypes2.default.func,
  rotateImage: _propTypes2.default.func,
  isTabletDevice: _propTypes2.default.bool,
  isMobile: _propTypes2.default.bool };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/UploadAssetWidget/Preview/PreviewList.js
// module id = 2927
// module chunks = 0